var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99951 5.5L6.49951 0.5C6.76216 0.5 7.02223 0.551732 7.26488 0.652241C7.50753 0.75275 7.72801 0.900069 7.91372 1.08579C8.09944 1.2715 8.24676 1.49198 8.34727 1.73463C8.44778 1.97728 8.49951 2.23736 8.49951 2.5V4H12.3667C12.5085 4 12.6487 4.03015 12.7779 4.08846C12.9072 4.14677 13.0226 4.2319 13.1164 4.3382C13.2102 4.4445 13.2804 4.56954 13.3222 4.70502C13.3641 4.84051 13.3766 4.98334 13.359 5.12403L12.609 11.124C12.5788 11.3659 12.4613 11.5884 12.2785 11.7497C12.0958 11.911 11.8605 12 11.6167 12H3.99951M0.999512 5.5H3.99951V12H0.999512C0.866903 12 0.739726 11.9473 0.645958 11.8536C0.55219 11.7598 0.499512 11.6326 0.499512 11.5V6C0.499512 5.86739 0.55219 5.74021 0.645958 5.64645C0.739726 5.55268 0.866903 5.5 0.999512 5.5V5.5Z",
    stroke: "#679CF6",
    strokeWidth: 0.969231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.b40d48bf302d3af5f9b68308ab201d5d.svg";
export { ForwardRef as ReactComponent };